function PointsAndRewards() {
  return <div>Something went wrong, please try again.</div>
}

export default PointsAndRewards
